const getFillAnimationValue = ({
  fillDuration, fillEasing, fillStaggerStep, fillDelay, i,
}) => `animate-svg-fill-${i + 1} ${fillDuration}s ${fillEasing} ${i * parseFloat(fillStaggerStep) + parseFloat(fillDelay)}s both`

export default getFillAnimationValue
